export const MYAPP_TITLE = {
  EDIT: "Edit App",
  CREATE: "Create New App",
};
